import { createContext } from "react";
import utilities from "../utils/utilities";
import { useWallet } from "@buidlerlabs/hashgraph-react-wallets";

const EditableContext = createContext({});

const WithEditProjectContext = (WrappedComponent) => {
  const WithEditProjectContext = (props) => {
    const { isConnected } = useWallet();

    return (
      <EditableContext.Provider value={{ editingEnabled: isConnected }}>
        <EditableContext.Consumer>
          {(value) => <WrappedComponent {...props} {...value} />}
        </EditableContext.Consumer>
      </EditableContext.Provider>
    );
  };

  WithEditProjectContext.displayName = `WithEditableConfig(${utilities.getDisplayName(WrappedComponent)})`;

  return WithEditProjectContext;
};

export default WithEditProjectContext;
